/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Keyboard } from "vr-react-components";
import { handleSetKeyboard } from "../../handlers/PrivateHandlers";
import { useEffect } from "react";
import { useState } from "react";

function KeyboardHandler() {
    const keyboardState = useSelector((state) => state.private.keyboard);
    const device = useSelector((state) => state.private.device);

    const isVR = device.isMobile || device.areControllersConnected;

    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((old) => old + 1)
    }, [keyboardState])

    return (
        <Keyboard
            key={key}
            state={keyboardState}
            isVR={isVR}
            aframeClasses={"collidable"}
            setKeyboard={(type, visible, callback) => {
                handleSetKeyboard(type, visible, callback)
            }}
        />
    );
}

export default KeyboardHandler;
